import classnames from 'classnames/bind'
import React, { useRef } from 'react'

import Slider from '@unlikelystudio/react-slider'

import Client, { ClientProps } from '~/components/Client'
import Image, { ImageProps } from '~/components/Image'
import Link, { LinkProps } from '~/components/Link'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ClientsProps {
  className?: string
  items: ClientProps[]
}
/**
 * Clients slider slice
 * @param props
 * @returns Slice
 */
function Clients({ className, items }: ClientsProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const customSliderRef = useRef()

  const sliderProps = {
    infinite: true,
    autoPlay: { speed: -1 },
  }

  return (
    <section className={cx(className, css.Clients)} ref={customSliderRef}>
      <div className={gridStyle}>
        <div className={css.content}>
          <Slider
            {...sliderProps}
            className={css.slider}
            customSliderRef={customSliderRef}>
            {items?.map((item, index) => (
              <Client {...item} className={css.client} key={`client${index}`} />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  )
}

Clients.defaultProps = {}

export default Clients
